import { ProductAnalyticsEventIdentity } from '@/api/analytics.ts';

const defineEvent = (
	category: string,
	feature: string,
	subfeature: string,
	action: string,
): ProductAnalyticsEventIdentity => ({
	category,
	feature,
	subfeature,
	action,
});

export const productAnalyticsEvents = {
	myClimate: {
		dataGap: {
			reviewTrips: {
				open: defineEvent('my_climate', 'data_gap', 'review_trips', 'open'),
			},
		},
		page: {
			aboutGoodwings: {
				help: defineEvent('my_climate', 'page', 'about_goodwings', 'help'),
			},
			learnMore: {
				help: defineEvent('my_climate', 'page', 'learn_more', 'help'),
			},
		},
		tripPlan: {
			overview: {
				open: defineEvent('my_climate', 'trip_plan', 'overview', 'open'),
			},
			discover: {
				open: defineEvent('my_climate', 'trip_plan', 'discover', 'open'),
			},
			transportation: {
				open: defineEvent('my_climate', 'trip_plan', 'transportation', 'open'),
				interact: defineEvent('my_climate', 'trip_plan', 'transportation', 'interact'),
			},
			placesToEat: {
				open: defineEvent('my_climate', 'trip_plan', 'places_to_eat', 'open'),
				interact: defineEvent('my_climate', 'trip_plan', 'places_to_eat', 'interact'),
				download: defineEvent('my_climate', 'trip_plan', 'places_to_eat', 'download'),
			},
			placesToRelax: {
				open: defineEvent('my_climate', 'trip_plan', 'places_to_relax', 'open'),
				interact: defineEvent('my_climate', 'trip_plan', 'places_to_relax', 'interact'),
				download: defineEvent('my_climate', 'trip_plan', 'places_to_relax', 'download'),
			},
		},
		carbonFootprint: {
			overview: {
				interact: defineEvent('my_climate', 'carbon_footprint', 'overview', 'interact'),
			},
		},
		metrics: {
			overview: {
				interact: defineEvent('my_climate', 'metrics', 'overview', 'interact'),
			},
		},
		tripLog: {
			overview: {
				help: defineEvent('my_climate', 'trip_log', 'overview', 'help'),
			},
			history: {
				open: defineEvent('my_climate', 'trip_log', 'history', 'open'),
				interact: defineEvent('my_climate', 'trip_log', 'history', 'interact'),
				submit: defineEvent('my_climate', 'trip_log', 'history', 'submit'),
			},
			logTrip: {
				open: defineEvent('my_climate', 'trip_log', 'log_trip', 'open'),
				interact: defineEvent('my_climate', 'trip_log', 'log_trip', 'interact'),
				submit: defineEvent('my_climate', 'trip_log', 'log_trip', 'submit'),
			},
			actionNeeded: {
				open: defineEvent('my_climate', 'trip_log', 'action_needed', 'open'),
				interact: defineEvent('my_climate', 'trip_log', 'action_needed', 'interact'),
				submit: defineEvent('my_climate', 'trip_log', 'action_needed', 'submit'),
			},
		},
	},
	climatePro: {
		dataGap: {
			tripDataCoverage: {
				help: defineEvent('climate_pro', 'data_gap', 'trip_data_coverage', 'help'),
				interact: defineEvent('climate_pro', 'data_gap', 'trip_data_coverage', 'interact'),
			},
			settings: {
				interact: defineEvent('climate_pro', 'data_gap', 'settings', 'interact'),
				submit: defineEvent('climate_pro', 'data_gap', 'settings', 'submit'),
			},
		},
		co2Budget: {
			setting: {
				interact: defineEvent('climate_pro', 'co2_budget', 'setting', 'interact'),
				submit: defineEvent('climate_pro', 'co2_budget', 'setting', 'submit'),
			},
			allocation: {
				interact: defineEvent('climate_pro', 'co2_budget', 'allocation', 'interact'),
				submit: defineEvent('climate_pro', 'co2_budget', 'allocation', 'submit'),
			},
			excessAlerts: {
				interact: defineEvent('climate_pro', 'co2_budget', 'excess_alerts', 'interact'),
				submit: defineEvent('climate_pro', 'co2_budget', 'excess_alerts', 'submit'),
			},
		},
		factorFramework: {
			overview: {
				help: defineEvent('climate_pro', 'factor_framework', 'overview', 'help'),
				interact: defineEvent('climate_pro', 'factor_framework', 'overview', 'interact'),
			},
		},
		metrics: {
			overview: {
				interact: defineEvent('climate_pro', 'metrics', 'overview', 'interact'),
			},
		},
		co2Dashboard: {
			overview: {
				interact: defineEvent('climate_pro', 'co2_dashboard', 'overview', 'interact'),
			},
		},
		forecastAnalytics: {
			overview: {
				interact: defineEvent('climate_pro', 'forecast_analytics', 'overview', 'interact'),
			},
		},
		compensationStatement: {
			sample: {
				download: defineEvent('climate_pro', 'compensation_statement', 'sample', 'download'),
			},
			overview: {
				interact: defineEvent('climate_pro', 'compensation_statement', 'overview', 'interact'),
			},
			file: {
				download: defineEvent('climate_pro', 'compensation_statement', 'file', 'download'),
			},
		},
		emissionReports: {
			overview: {
				interact: defineEvent('climate_pro', 'emission_reports', 'overview', 'interact'),
			},
			report: {
				download: defineEvent('climate_pro', 'emission_reports', 'report', 'download'),
			},
		},
		page: {
			overview: {
				help: defineEvent('climate_pro', 'page', 'overview', 'help'),
			},
		},
	},
	profileMenu: {
		securitySettings: {
			changePassword: {
				submit: defineEvent('profile_menu', 'security_settings', 'change_password', 'submit'),
			},
			twoFactorAuth: {
				submit: defineEvent('profile_menu', 'security_settings', 'two_factor_auth', 'submit'),
			},
		},
	},
} as const;

export const travelLogAdoptionEvents = {
	flight: defineEvent('my_climate', 'trip_log', 'flight', 'log'),
	accommodation: defineEvent('my_climate', 'trip_log', 'accommodation', 'log'),
	mileage: defineEvent('my_climate', 'trip_log', 'mileage', 'log'),
} as const;
